module.exports = __webpack_public_path__ + "static/media/aiomeet-logo-square.349793eb.png";